import AccessSelector from './AccessSelector'

export default AccessSelector
